import { render, staticRenderFns } from "./home-registration.vue?vue&type=template&id=0521bc31&scoped=true&"
import script from "./home-registration.vue?vue&type=script&lang=js&"
export * from "./home-registration.vue?vue&type=script&lang=js&"
import style0 from "./home-registration.vue?vue&type=style&index=0&id=0521bc31&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0521bc31",
  null
  
)

export default component.exports